import { useEffect } from 'react';

import { getAnalytics, logEvent } from 'firebase/analytics';

import { Routes, Route, useLocation } from 'react-router-dom';

import ClouderRoutes from './ClouderRoutes';
import OnboardingRoutes from './OnboardingRoutes';
import PrivateRoute from './PrivateRoute';

import {
  LoginPage,
  PasswordResetPage,
  PasswordRequestPage,
  PasswordRequestSuccessPage,
  PasswordResetSuccessPage,
} from '../features/auth';
import { TermsPage } from '../features/legal';

const AppRoutes = () => {
  const location = useLocation();
  const analytics = getAnalytics();

  useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_location: window.location.href,
    });
  }, [analytics, location]);

  return (
    <Routes>
      <Route path="/password-request" element={<PasswordRequestPage />} />
      <Route
        path="/password-request-success"
        element={<PasswordRequestSuccessPage />}
      />
      <Route path="/reset-password" element={<PasswordResetPage />} />
      <Route
        path="/reset-password-success"
        element={<PasswordResetSuccessPage />}
      />
      <Route path="/terms" element={<TermsPage />} />
      <Route element={<PrivateRoute module="login" />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
      <Route path="/onboarding/*" element={<OnboardingRoutes />} />
      <Route path="/*" element={<ClouderRoutes />} />
    </Routes>
  );
};

export default AppRoutes;
